import Analytics, { AnalyticsPlugin } from "analytics";
import googleTagManager from "@analytics/google-tag-manager";

import { getAnalyticsConfig } from "@chemaxon/terminus-client/ui/utils/config";

const ANALYTICS_APP_NAME = "terminus";

export enum GtmCustomEvents {
  PendoInitUser = "pendo_init_user",
}

const analyticsConfig = getAnalyticsConfig();

const plugins: AnalyticsPlugin[] = [];

if (analyticsConfig?.googleTagManager?.containerId) {
  plugins.push(googleTagManager(analyticsConfig.googleTagManager));
}

const analyticsInstance = Analytics({
  app: ANALYTICS_APP_NAME,
  plugins,
});

export { analyticsInstance };
